module.exports = __webpack_public_path__ + "img/status_3.d1b1ac9a.png";